export default __webpack_public_path__ + "static/media/calendar.d32f14b0.svg";